export const initial_Payament_start = "initial_Payament_start"
export const initial_Payament_success = "initial_Payament_success"
export const initial_Payament_failed = "initial_Payament_failed"

export const get_coupon_start = "get_coupon_start"
export const get_coupon_success = "get_coupon_success"
export const get_coupon_fail = "get_coupon_fail"
export const get_coupon_reset = "get_coupon_reset"
